import { render, staticRenderFns } from "./expendDetails.vue?vue&type=template&id=059334a6&scoped=true"
import script from "./expendDetails.vue?vue&type=script&lang=js"
export * from "./expendDetails.vue?vue&type=script&lang=js"
import style0 from "./expendDetails.vue?vue&type=style&index=0&id=059334a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059334a6",
  null
  
)

export default component.exports